import Marquee from "react-fast-marquee";

const WORDS = [
  "Freshly Made",
  "Handmade Onigiri",
  "Corporate Catering",
  "Sushi Platters",
  "Authentic Flavours",
  "Bento Boxes",
  "Auckland",
];

export const EditorialMarquee = () => (
  <section
    data-testid="marquee-section"
    className="bg-sage py-8 border-y border-sage/40 overflow-hidden"
  >
    <Marquee speed={40} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-cream text-4xl md:text-6xl px-8">
            {w}
          </span>
          <span className="text-gold text-3xl md:text-5xl">&#10022;</span>
        </span>
      ))}
    </Marquee>
  </section>
);
